import React, { useEffect, useState } from "react";
import styles from "../styles/StudyDestination.module.scss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import CustomImage from "./CustomImage";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import WebinarEvents from "./WebinarEvents";
import FeaturedBlogs from "./FeaturedBlogs";
import Form from "react-bootstrap/Form";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { useRouter } from "next/router";
import TopTieUpsOfKC from "./UniTieUp";
import TabNav from "./UI/TabNav/TabNav";
import KcNewLatestUpdates from "./kcNewlatestupdates";
import FaqComponent from "./PST/FrequentlyAskedQuestions";
import VideoTestimonials from "./PST/VideoTestimonials";
import NewNeedGuidance from "./NewNeedGuidance";
import { isFrappeOrJotFormClass } from "../utils/helpers";
import { getOnboardingOrFormCtaProps } from "../utils/applyCtaButtonProps";
import { PRIMARY_SOURCE_B2C_WIDGET } from "../utils/b2c/constants";
import { persistSourceContext } from "../utils/b2c/sourceTracking";

const StudyDestination: React.FC = (props: any) => {
  const router = useRouter();
  const { query } = router;
  const studyDestinationData = props?.pageData;
  const [selectedDestination, setSelectedDestination] = useState<any>(
    query.slug
      ? props?.countryData[0]?.studycountries[0]
      : props?.pageData?.studycountries[0],
  );
  const [searchDestination, setSearchDestination] = useState<string>("");
  const bannerToOnboardingEnabled = studyDestinationData?.bannerBtn?.toOnboardingEnabled;
  const applyCtaButtonProps = getOnboardingOrFormCtaProps(router, {
    btnLink: studyDestinationData?.bannerBtn?.btnLink,
    formId: studyDestinationData?.bannerBtn?.formId || (bannerToOnboardingEnabled ? undefined : 'main-enquiry-form'),
    toOnboardingEnabled: bannerToOnboardingEnabled,
  });

  useEffect(() => {
    window.addEventListener("scroll", renderStickyHeader);
    return () => {
      window.removeEventListener("scroll", renderStickyHeader);
    };
  });

  const renderStickyHeader = () => {
    const header = document.getElementById("header");
    const scrollTop = window.scrollY;
    const startScroll = window.screen.width <= 900 ? 2100 : 1200;
    scrollTop >= startScroll && header
      ? header?.classList.add(styles.headerDisplay)
      : header?.classList.remove(styles.headerDisplay);
  };
  const studyCountries = query.slug
    ? props?.countryData[0]?.studycountries
    : props?.pageData?.studycountries;

  const enquireNowClickHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (applyCtaButtonProps.mode === "onboarding") {
      persistSourceContext({
        sourceUrl: window.location.href,
        primarySource: PRIMARY_SOURCE_B2C_WIDGET,
        fifthStepVisible:
          studyDestinationData?.bannerBtn?.onBoardingFlow
            ?.nearestOffice ?? true,
        coachingVisible:
          studyDestinationData?.bannerBtn?.onBoardingFlow
            ?.lookingForCoaching ?? true, // CFM-1514
      });
    }

    applyCtaButtonProps.onClick?.(e);
  };

  return (
    <>
      <div className={styles.stickyHead} id="header">
        <TabNav
          items={studyCountries.length > 0 ? studyCountries.map((studyDestination: any) => ({
            id: studyDestination.id,
            label: studyDestination.title,
          })) : []}
          activeId={selectedDestination?.id}
          onSelect={(item) => {
            const studyDestination = studyCountries.find(
              (country: any) => country.id === item.id,
            );
            setSelectedDestination(studyDestination);
            if (query.slug) {
              router.push(
                `/study-destinations/${
                  query.slug
                }#${studyDestination.title.replace(/ /g, "")}`,
              );
            } else
              router.push(
                `/study-destinations#${studyDestination.title.replace(
                  / /g,
                  "",
                )}`,
              );
          }}
        />
      </div>
      <div id="study-destination" className={styles.studyDestinationBg}>
        <Container>
          <Row>
            <Col xs={12} lg={7} className={styles.mainContent}>
              <Breadcrumb className={styles.breadcrum}>
                <Breadcrumb.Item style={{ opacity: 0.5 }} href="/">
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item href="">Study Destinations</Breadcrumb.Item>
              </Breadcrumb>
              <h1 className="mb-3">
                {(props?.countryData?.length > 0 &&
                  props?.countryData[0]?.mainTitle) ||
                  props?.pageData?.title}
              </h1>
              <p>
                {(props?.countryData?.length > 0 &&
                  props?.countryData[0]?.mainDescription) ||
                  props?.pageData?.description}
              </p>

              <Button
                variant="primary"
                size="lg"
                onClick={enquireNowClickHandler}
                className={`btn ${applyCtaButtonProps.formClassName}`}
              >
                {props?.pageData?.bannerBtn?.label || "Enquire Now"}
              </Button>
            </Col>
            <Col xs={12} lg={5} className={`${styles.globe} text-center`}>
              <CustomImage
                src={
                  (props?.countryData?.length > 0 &&
                    props?.countryData[0]?.mainImageUrl) ||
                  props?.pageData?.mainImageUrl
                }
                alt={
                  (props?.countryData?.length > 0 &&
                    props?.countryData[0]?.mainImageAltTag) ||
                  props?.pageData?.mainImageAltTag
                }
                width={525}
                height={525}
              />
            </Col>
          </Row>
        </Container>
      </div>
      <div id="search-studydesti" className={styles.searchStudyDesti}>
        <div className={styles.searchPan}>
          <div className={styles.searchBox}>
            <h2 className="text-center">Search your Study Destination</h2>
            <div className={styles.subscribeForm}>
              <div>
                <Form.Select
                  placeholder="Select Country"
                  onChange={(event: any) =>
                    setSearchDestination(event.target.value)
                  }
                >
                  <option>Select Country</option>
                  {studyCountries.length > 0 &&
                    studyCountries.map((destination: any, index: number) => {
                      return <option key={index}>{destination.title}</option>;
                    })}
                </Form.Select>
              </div>
              <div>
                <button
                  onClick={() => {
                    if (
                      searchDestination &&
                      searchDestination !== "Select Country"
                    ) {
                      const filteredDestination = studyCountries.filter(
                        (country: any) => country.title === searchDestination,
                      )[0];
                      setSelectedDestination(filteredDestination);
                      if (query.slug) {
                        router.push(
                          `/study-destinations/${
                            query.slug
                          }#${filteredDestination.title.replace(/ /g, "")}`,
                        );
                      } else
                        router.push(
                          `/study-destinations#${filteredDestination.title.replace(
                            / /g,
                            "",
                          )}`,
                        );
                    }
                  }}
                >
                  <CustomImage
                    src="/new-images/search-sign.svg"
                    width={19}
                    height={19}
                    alt="searchSign.svg"
                  />
                  <span className={styles.searchtxt}>Search</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="our-strengths" className={styles.Strengths}>
        <Container>
          <h2 className="text-center mb-5">Our Strengths</h2>
          <Row className="text-center">
            {props?.pageData?.ourStrengths?.length > 0 &&
              props?.pageData?.ourStrengths?.map((section: any) => {
                return (
                  <Col xs={12} md={4} lg={4} key={section?.id}>
                    <div className={styles.StrengthsContent}>
                      <div>
                        <CustomImage
                          src={section.imagePath}
                          width={105}
                          height={75}
                          alt={section.imageAltTag}
                        />
                      </div>
                      <h3>{section?.title}</h3>
                      <p>{section?.description}</p>
                    </div>
                  </Col>
                );
              })}
          </Row>
        </Container>
      </div>

      <div id="study-countriess">
        <h2 className={styles.exploreTitle}>Explore our study destinations!</h2>
        {studyCountries.map((country: any, ind: number) => {
          return (
            <div
              className={styles.exploreDivBlue}
              style={{ backgroundColor: country.bgcolor }}
              key={ind}
            >
              <span
                className={styles.alignTop}
                id={country.title.replace(/ /g, "")}
              />
              <div className={styles.studyServSection}>
                <Container>
                  <Row className={country.type === "one" ? styles.row : ""}>
                    {country.type === "one" ? (
                      <>
                        <Col xs={12} lg={6} className={styles.txtPosition}>
                          <div className={styles.studyContent}>
                            <h3 className="mb-4">{country.title}</h3>
                            <p>{country.description}</p>
                            <h4>Quick facts</h4>
                            <ul className="pl-0">
                              {country.quickfacts.map(
                                (fact: string, index: number) => (
                                  <li key={index}>{fact}</li>
                                ),
                              )}
                            </ul>
                            {query.slug && !country.link ? (
                              <div
                                className={`${styles.enqBtn} btn ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0]?.jotformid)}`}
                              >
                                Enquire Now
                              </div>
                            ) : (
                              <a href={country.link}>Know More</a>
                            )}
                          </div>
                        </Col>
                        <Col
                          xs={12}
                          lg={6}
                          className={`${styles.imgPosition}  ${styles.justifyContentEnd}`}
                        >
                          <div className={styles.platformDivImg}>
                            <div
                              className={styles.picRound}
                              style={{
                                backgroundColor: country?.bgCircleColor,
                              }}
                            ></div>
                            <div className={styles.pica}>
                              <CustomImage
                                src={country?.image1 || "/cana_a.svg"}
                                width={200}
                                height={200}
                                alt={country?.imageAltTag1}
                              />
                            </div>
                            <div className={styles.picb}>
                              <CustomImage
                                src={country?.image2 || "/cana_b.svg"}
                                width={200}
                                height={280}
                                alt={country?.imageAltTag2}
                              />
                            </div>
                            <div className={styles.picc}>
                              <CustomImage
                                src={country?.image3 || "/cana_c.svg"}
                                width={200}
                                height={280}
                                alt={country?.imageAltTag3}
                              />
                            </div>
                            <div className={styles.picd}>
                              <CustomImage
                                src={country?.image4 || "/cana_d.svg"}
                                width={200}
                                height={200}
                                alt={country?.imageAltTag4}
                              />
                            </div>
                          </div>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col
                          xs={12}
                          lg={6}
                          className={`${styles.imgPosition} ${styles.justifyContentStart}`}
                        >
                          <div className={styles.platformDivImg}>
                            <div
                              className={styles.picRound}
                              style={{
                                backgroundColor: country?.bgCircleColor,
                              }}
                            ></div>
                            <div className={styles.pica}>
                              <CustomImage
                                src={country?.image1 || "/cana_a.svg"}
                                width={200}
                                height={200}
                                alt={country?.imageAltTag1}
                              />
                            </div>
                            <div className={styles.picb}>
                              <CustomImage
                                src={country?.image2 || "/cana_b.svg"}
                                width={200}
                                height={280}
                                alt={country?.imageAltTag2}
                              />
                            </div>
                            <div className={styles.picc}>
                              <CustomImage
                                src={country?.image3 || "/cana_c.svg"}
                                width={200}
                                height={280}
                                alt={country?.imageAltTag3}
                              />
                            </div>
                            <div className={styles.picd}>
                              <CustomImage
                                src={country?.image4 || "/cana_c.svg"}
                                width={200}
                                height={200}
                                alt={country?.imageAltTag4}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col xs={12} lg={6}>
                          <div className={styles.studyContent}>
                            <h3 className="mb-4">{country.title}</h3>
                            <p>{country.description}</p>
                            <h4>Quick facts</h4>
                            <ul className="pl-0">
                              {country.quickfacts.map(
                                (fact: string, index: number) => (
                                  <li key={index}>{fact}</li>
                                ),
                              )}
                            </ul>
                            {query.slug && !country.link ? (
                              <div
                                className={`${styles.enqBtn} btn ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0]?.jotformid)}`}
                              >
                                Enquire Now
                              </div>
                            ) : (
                              <a href={country.link}>Know More</a>
                            )}
                          </div>
                        </Col>
                      </>
                    )}
                  </Row>
                </Container>
              </div>
            </div>
          );
        })}
      </div>
      {props.pageData?.videoTestimonial && (
        <VideoTestimonials {...props.pageData.videoTestimonial} />
      )}
      <WebinarEvents headingLevel={2}/>
      <div className={styles.uniTieUp}>
        <TopTieUpsOfKC />
      </div>

      <div className={styles.homePageLatestKcUpdates}>
        <KcNewLatestUpdates {...props} />
      </div>

      <div className={styles.homePageBlogs}>
        <FeaturedBlogs />
      </div>
      {props?.countryData?.[0]?.faq && <FaqComponent {...props?.countryData?.[0]?.faq} />}
      {props?.pageData?.needGuidance && (
        <NewNeedGuidance
          data={props?.pageData?.needGuidance}
          jotforms={props?.pageData?.meta?.jotforms}
          externalLink={props?.pageData?.externalLink}
        />
      )}
    </>
  );
};

export default StudyDestination;
